import React from "react"

import Layout from "../components/layout/layout"
import Future from "../components/sections/future"
import SEO from "../components/seo/seo"
import styled from "styled-components"
import FullScreenCarousel from "../components/ui/fullscreen-carousel"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Address from "../components/sections/visiting-plan-visit"
import Container, { Row, Third, TwoThird } from "../components/layout/container"
import Sidemenu from "../layout/sidebar";
import VisitingSidemenu from "../components/layout/sidebar-visiting";
import GettingHere from "../components/sections/getting-here"
import MarketMap from "../components/sections/market-map"
import RecentPosts from "../components/sections/recent-posts"
import PlanVisit from "../components/sections/plan-your-visit"
import Access from "../components/sections/access"
import Faqs from "../components/sections/faqs"
import Map from "../components/sections/map"

const ContainerRowChange = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: ${(props) =>
      props.theme.breakpoints.tablet}) {
    flex-direction: row;
  }
  @media screen and (max-width: ${(props) =>
      props.theme.breakpoints.phone}) {
    flex-direction: column;
  }
`

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="" description="" />
        <Container>
            <ContainerRowChange>
                <Third>
                    <VisitingSidemenu />
                </Third>
                <TwoThird>
                    <Address />
                    <GettingHere />
                    <Map />
                    <MarketMap />
                    <Access />
                    <Faqs />
                    <RecentPosts />
                    <PlanVisit />
                </TwoThird>
            </ContainerRowChange>
        </Container>
    </Layout>
  );
}

export default IndexPage